import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0B0E14] flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl bg-[#121721] border border-white/10 p-8 text-center space-y-5">
        <XCircle className="h-14 w-14 text-slate-500 mx-auto" />
        <h1 className="text-xl font-bold text-white">Payment cancelled</h1>
        <p className="text-slate-400 text-sm">No charge was made. Your accepted offer is still waiting whenever you're ready.</p>
        <Button data-testid="cancel-back" onClick={() => navigate("/my-deals")} className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold h-11 rounded-full">
          Back to my deals
        </Button>
      </div>
    </div>
  );
}
